import { render, staticRenderFns } from "./AddEndDateDialog.vue?vue&type=template&id=12c5d565&scoped=true"
import script from "./AddEndDateDialog.vue?vue&type=script&lang=js"
export * from "./AddEndDateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c5d565",
  null
  
)

export default component.exports